<template>
  <div class="content promotion">
    <div class="category-tabs-container">
      <div class="category-tabs">
        <button 
          v-for="item in sortedCategoriesArray" 
          :key="item.key"
          :class="{ active: activeCategory === item.key }"
          @click="filterByCategory(item.key)"
        >
          {{ item.value }}
        </button>
      </div>
    </div>
    <div class="promo-list">
      <div 
        v-for="(item, index) in filteredPagedList" 
        :key="item.id" 
        class="promo-card" 
        @click="$parent.goNav(`/activeInfo?id=${item.id}`)"
      >
        <div class="promo-img">
          <img :src="item.banner" alt="活动图" />
          <div class="promo-label" :class="{ expired: isExpired(item.updated_at) }">
            {{ isExpired(item.updated_at) ? '已过期' : '新活动' }}
          </div>
        </div>
        <div class="promo-info">
          <h3 class="promo-title">{{ item.title }}</h3>
          <span class="promo-date">
            {{ formatDate(item.updated_at) }}
          </span>
        </div>
      </div>
      <div class="empty-state" v-if="filteredList.length === 0">
        <i class="fas fa-box-open"></i>
        <p>该分类下暂无活动</p>
      </div>
    </div>
    <div v-if="filteredList.length > pageSize" class="pagination">
      <button 
        :disabled="currentPage === 1" 
        @click="currentPage--"
      >上一页</button>
      <span>第 {{ currentPage }} 页 / 共 {{ totalPages }} 页</span>
      <button 
        :disabled="currentPage === totalPages" 
        @click="currentPage++"
      >下一页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActiveList',
  data() {
    return { 
      activitylistList: [],
      currentPage: 1,
      pageSize: 5,
      activeCategory: 'all', // 默认显示全部
      categories: {
        'all': '全部活动',
        '2': '现金回馈',
        '5': '棋牌活动',
        '6': '电子活动',
        '7': '彩票活动',
        '8': '视讯活动',
        '9': '热门优惠'
      }
    };
  },
  computed: {
    sortedCategoriesArray() {
      const otherCategories = Object.keys(this.categories)
        .filter(key => key !== 'all')
        .map(key => ({
          key,
          value: this.categories[key],
          numKey: Number(key)
        }))
        .sort((a, b) => a.numKey - b.numKey); // 按数字键从小到大排序
      return [
        { key: 'all', value: this.categories.all }
      ].concat(otherCategories);
    },
    filteredList() {
      let filtered = [];
      if (this.activeCategory === 'all') {
        filtered = [...this.activitylistList];
      } else {
        filtered = this.activitylistList.filter(item => 
          item.type.toString() === this.activeCategory
        );
      }
      return filtered.sort((a, b) => {
        const aExpired = this.isExpired(a.updated_at);
        const bExpired = this.isExpired(b.updated_at);
        if (!aExpired && bExpired) return -1;
        if (aExpired && !bExpired) return 1;
        return new Date(b.updated_at) - new Date(a.updated_at);
      });
    },
    totalPages() {
      return Math.ceil(this.filteredList.length / this.pageSize);
    },
    filteredPagedList() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredList.slice(start, start + this.pageSize);
    }
  },
  created() {
    this.activitylist();
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },	  
    activitylist() {
      const info = { type: '' };
      this.$parent.showLoading();
      this.$apiFun.post('/api/activitylist', info).then(res => {
        if (res.code !== 200) {
          this.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          this.activitylistList = res.data.data;
        }
        this.$parent.hideLoading();
      });
    },
    filterByCategory(category) {
      this.activeCategory = category;
      this.currentPage = 1; // 切换分类时重置到第一页
    },
    isExpired(dateString) {
      if (!dateString) return true;
      const activityDate = new Date(dateString);
      const currentDate = new Date();
      return activityDate.getFullYear() !== currentDate.getFullYear() || 
             activityDate.getMonth() !== currentDate.getMonth();
    }
  },
  watch: {
    activitylistList() {
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #f8fafc;
  min-height: 100vh;
  padding: 20px;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
.category-tabs-container {
  position: relative;
  padding-bottom: 5px;
  margin-bottom: 20px;
}

.category-tabs {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 10px;
  scrollbar-width: none; /* 隐藏滚动条 */
  -webkit-overflow-scrolling: touch; /* 平滑滚动 - 针对iOS设备 */
  scroll-behavior: smooth; /* 平滑滚动 */
}
.category-tabs::-webkit-scrollbar {
  height: 4px;
  display: block;
}
.category-tabs::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}
.category-tabs::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 10px;
}
.category-tabs::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.category-tabs button {
  padding: 6px 16px;
  background-color: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  font-size: 14px;
  color: #4a5568;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0; /* 防止按钮被压缩 */
}
.category-tabs button.active {
  background-color: #3b82f6;
  color: white;
  border-color: #3b82f6;
}
.category-tabs button:hover:not(.active) {
  border-color: #90cdf4;
  color: #3182ce;
}
.promo-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.promo-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: all 0.3s ease;
}
.promo-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
}
.promo-img {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
}
.promo-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  filter: grayscale(var(--grayscale, 0));
}
.promo-label {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 12px;
  font-weight: 500;
}
.promo-label:not(.expired) {
  background-color: #ff4d4f;
  color: #fff;
}
.promo-label.expired {
  background-color: #9ca3af;
  color: #fff;
}
.promo-card:has(.promo-label.expired) {
  --grayscale: 1;
  opacity: 0.9;
}
.promo-info {
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.promo-title {
  max-width: 210px;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  flex: 1;
  white-space: nowrap; /* 禁止文字换行 */
  overflow: hidden;    /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}
.promo-date {
  font-size: 12px;
  color: #718096;
  display: flex;
  align-items: center;
  gap: 6px;
}
.expired-tag {
  background-color: #fef2f2;
  color: #dc2626;
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 4px;
}
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #a0aec0;
}
.empty-state i {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
  padding-bottom: 20px;
}
.pagination button {
  padding: 6px 12px;
  border: none;
  background-color: #4a90e2;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease;
}
.pagination button:disabled {
  background-color: #cbd5e0;
  cursor: not-allowed;
}
.pagination button:hover:not(:disabled) {
  background-color: #3b82f6;
}
@media (max-width: 480px) {
  .promo-img {
    height: 140px;
  }
  .promo-title {
    font-size: 14px;
  }
  .promo-date {
    font-size: 11px;
  }
  .category-tabs {
    gap: 8px;
  }
  .category-tabs button {
    padding: 5px 12px;
    font-size: 13px;
  }
}
</style>
    


// WEBPACK FOOTER //
// src/components/main/activeList.vue